<template>
  <b-form-group :label="label" :label-for="inputId">
    <b-input-group>
      <template #append>
        <b-input-group-text class="cursor-pointer" @click="clearDateRange">
          <strong
            :class="dateRange && dateRange.length > 0 ? 'text-danger' : ''"
          >
            <feather-icon
              :icon="
                dateRange && dateRange.length > 0 ? 'Trash2Icon' : 'ClockIcon'
              "
              size="16"
            />
          </strong>
        </b-input-group-text>
      </template>
      <b-form-input
        :class="inputId"
        :max="max"
        :id="inputId"
        placeholder="بازه‌ی تاریخ را انتخاب کنید"
      ></b-form-input>
    </b-input-group>
    <date-picker
      range
      v-model="dateRange"
      :clearable="true"
      class="absolute"
      :customInput="`.${inputId}`"
      display-format="jYYYY/jMM/jDD"
      input-format="YYYY/MM/DD"
      format="YYYY-MM-DD"
    ></date-picker>
  </b-form-group>
</template>
<script>
export default {
  emits: ["getDateRange"],
  props: {
    inputId: {
      type: [String],
      required: false,
      default: "rangeDateSelector",
    },
    max: {
      type: [String, Date, null],
      required: false,
    },
    label: {
      type: [String, null],
      default: "بازه‌ی تاریخ را انتخاب کنید",
    },
    defaultDateRange: {
      type: [Array, null],
      default: null,
    },
  },
  watch: {
    defaultDateRange: {
      handler(val) {
        if (val) {
          this.dateRange = val;
        }
      },
      immediate: true,
    },
    dateRange: {
      handler(val) {
        this.$emit("getDateRange", this.dateRange);
      },
    },
  },
  data() {
    return {
      dateRange: null,
    };
  },
  methods: {
    clearDateRange() {
      this.dateRange = null;
    },
  },
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupText,
    BFormInput,
  },
};
import {
  BFormGroup,
  BInputGroup,
  BInputGroupText,
  BFormInput,
} from "bootstrap-vue";
</script>
